The partner's unique reference for the hiring organization.
